import setting from '@/views/setting/setting';
export default setting;